/**
 * Plant categories.
 *
 * Previously each component carried its own copy of these labels, with
 * emoji baked into the strings and the wording drifting between the card,
 * the filter and the admin table ("Flowering" vs "Flowering Plants").
 * One list, used everywhere.
 */
export const CATEGORIES = [
  { value: 'fruit_trees', label: 'Fruit trees' },
  { value: 'flowering_plants', label: 'Flowering plants' },
  { value: 'perennials', label: 'Perennials' },
  { value: 'seasonal_plants', label: 'Seasonal plants' },
  { value: 'vegetables', label: 'Vegetables' },
];

export const CATEGORY_LABELS = CATEGORIES.reduce(
  (acc, c) => ({ ...acc, [c.value]: c.label }),
  {}
);

export function categoryLabel(value) {
  return CATEGORY_LABELS[value] || value;
}
